import { mount } from "@vue/test-utils";
import EmailField from "@/components/core/EmailField";

jest.mock("@/components/core/EmailField", () => ({
  ...jest.requireActual("@/components/core/EmailField"),
  methods: {
    subscribe: jest.fn()
  }
}));

describe("EmailField test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(EmailField, {
      props: {
        value: "asdasd@mail.com",
        label: "asdasd",
        required: false
      }
    });
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component EmailField", () => {
    expect(wrapper).toBeDefined();
  });
});
